var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"traffic-light"},on),[_c('div',{staticClass:"light-bulb",style:({ backgroundColor: _vm.color })}),_c('div',{staticClass:"light-label"},[_vm._v(_vm._s(_vm.label))])])]}}])},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }